<template>
  <CustomUpdateDialog
    :dialogTitle="`ویرایش ${resourceDetailSectionTitle}`"
    dialogId="update-resource-detail-section-dialog"
    noCloseOnBackdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendUpdateResourceDetailRequest"
  >
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="resource-content-title"
        inputLabel="عنوان بخش"
        inputPlaceholder="گرامر..."
        v-model="updateResourceContentSectionPayload.title"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <BFormGroup label="توضحیات بخش" label-for="resource-content-desc">
        <BFormTextarea
          rows="5"
          v-model="updateResourceContentSectionPayload.description"
          size="sm"
          id="resource-content-desc"
          placeholder="منابع مورد نیاز برای گرامر..."
        ></BFormTextarea>
      </BFormGroup>
    </BCol>
    <BCol cols="12">
      <BFormGroup
        label="تصویر اصلی بخش"
        label-for="resourceContentSectionImageFile"
      >
        <BFormFile
          v-model="updateResourceContentSectionPayload.imageFile"
          ref="resourceContentSectionImageFile"
          id="resourceContentSectionImageFile"
          accept="jpg,.jpeg,.png"
          @input="handleImageFile"
        ></BFormFile>
      </BFormGroup>
    </BCol>
    <BCol
      cols="12"
      class="position-relative"
      v-if="updateResourceContentSectionPayload.imageFile"
    >
      <BImg
        rounded
        class="custom-image"
        center
        fluid
        :src="resourceContentSectionimagePreview"
      ></BImg>

      <BButton
        size="sm"
        variant="transparent"
        class="custom-delete-btn"
        @click="deletePreviewImage"
      >
        <FeatherIcon size="40" class="text-danger" icon="Trash2Icon" />
      </BButton>
    </BCol>
    <BCol cols="12">
      <hr />
    </BCol>
    <BCol
      cols="12"
      v-for="(item, index) in updateResourceContentSectionPayload.attachments"
      :key="index"
    >
      <BRow>
        <BCol cols="12" class="py-0 my-0">
          <div class="w-100 d-flex align-items-center justify-content-between">
            <p style="font-size: 12px">فایل {{ index + 1 }}</p>
            <BButton
              size="sm"
              variant="danger"
              @click="removeAttachment(index)"
            >
              حذف فایل
            </BButton>
          </div>
        </BCol>
        <BCol cols="12">
          <ResourceAttachmentTypePicker
            :defaultSelectedType="item.resourceDetailAttachmentType"
            v-model="item.resourceDetailAttachmentType"
          ></ResourceAttachmentTypePicker>
        </BCol>
        <BCol cols="12">
          <BFormGroup label="فایل" :label-for="`imageFile${index}`">
            <BFormFile
              v-model="item.imageFile"
              ref="imageFile"
              :id="`imageFile${index}`"
              :accept="
                attachmentTypeMimeTypes[item.resourceDetailAttachmentType]
              "
            ></BFormFile>
          </BFormGroup>
        </BCol>
      </BRow>
    </BCol>
    <BCol cols="12" v-if="uploaded">
      <p class="mb-0">در حال آپلود {{ uploaded + "%" }}</p>
      <b-progress animated v-model="uploaded" max="100" />
    </BCol>
    <BCol cols="12">
      <BButton
        class="w-100 my-1"
        variant="primary"
        @click="addNewFileAttachment"
      >
        افزودن فایل
      </BButton>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    resourceDetailContentSection: {
      type: Object,
    },
  },
  watch: {
    resourceDetailContentSection: {
      immediate: true,
      handler(val) {
        if (val) {
          this.updateResourceContentSectionPayload =
            this.resourceDetailContentSection;
        }
      },
    },
  },
  data() {
    return {
      uploaded: null, // Webservice fill this value with upload percentage automatically
      isOkButtonDisabled: false,
      updateResourceContentSectionPayload: {
        resourceDetailContentSectionId: null,
        imageFile: null,
        title: null,
        description: null,
        attachments: [
          {
            resourceDetailAttachmentType: 1,
            imageFile: null,
          },
        ],
      },
      resourceContentSectionimagePreview: null,
      attachmentTypeMimeTypes: {
        1: ".jpg,.jpeg,.png",
        2: ".mp3,.wav",
        3: ".mp4,.mov",
        4: ".pdf",
      },
    };
  },
  methods: {
    handleImageFile() {
      if (
        this.updateResourceContentSectionPayload &&
        this.updateResourceContentSectionPayload.imageFile
      ) {
        this.resourceContentSectionimagePreview = URL.createObjectURL(
          this.updateResourceContentSectionPayload.imageFile
        );
      }
    },
    deletePreviewImage() {
      if (
        this.updateResourceContentSectionPayload &&
        this.updateResourceContentSectionPayload.imageFile
      ) {
        URL.revokeObjectURL(this.resourceContentSectionimagePreview);
        this.resourceContentSectionimagePreview = null;
        this.updateResourceContentSectionPayload.imageFile = null;
        if (
          this.$refs.resourceContentSectionImageFile &&
          this.$refs.resourceContentSectionImageFile
        ) {
          this.$refs.resourceContentSectionImageFile.reset();
        }
      }
    },
    removeAttachment(index) {
      this.updateResourceContentSectionPayload.attachments.splice(index, 1);
    },
    addNewFileAttachment() {
      this.updateResourceContentSectionPayload.attachments.push({
        resourceDetailAttachmentType: 1,
        imageFile: null,
      });
    },
    async sendUpdateResourceDetailRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let updateResourceDetailContentSection =
          new UpdateResourceDetailContentSection(_this);
        updateResourceDetailContentSection.setFormData(
          helper.generateFormData(_this.updateResourceContentSectionPayload)
        );
        await updateResourceDetailContentSection.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.uploaded = null;
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "بخش جدید با موفقیت به منبع شما اضافه شد.",
              },
            });
            _this.updateResourceContentSectionPayload = {
              resourceDetailId: null,
              title: null,
              description: null,
              attachments: [
                {
                  resourceDetailAttachmentType: 1,
                  imageFile: null,
                },
              ],
            };
            _this.$bvModal.hide("update-resource-detail-section-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه نشد!",
                icon: "XIcon",
                variant: "danger",
                text:
                  res.data.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    resourceDetailSectionTitle() {
      if (
        this.resourceDetailContentSection &&
        this.resourceDetailContentSection.title
      ) {
        return this.resourceDetailContentSection.title;
      }
      return "";
    },
  },
  components: {
    ResourceAttachmentTypePicker,
    CustomUpdateDialog,
    TextInput,
    BCol,
    BFormGroup,
    BFormTextarea,
    BButton,
    BFormFile,
    BProgress,
    BRow,
    BImg,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import ResourceAttachmentTypePicker from "@/views/components/Resources/ResourceAttachmentTypePicker.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import helper from "@/libs/Helper";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormTextarea,
  BButton,
  BFormFile,
  BImg,
  BProgress,
} from "bootstrap-vue";
import { UpdateResourceDetailContentSection } from "@/libs/Api/Resources";
</script>
